import { useTranslation } from 'react-i18next';

export default function WhatIsSection() {
  const { t, i18n } = useTranslation();
  const prefix = i18n.language === 'pt' ? '' : '/' + i18n.language;

  const points = [
    { icon: 'ri-grid-line', text: t('whatIs.point1') },
    { icon: 'ri-links-line', text: t('whatIs.point2') },
    { icon: 'ri-image-line', text: t('whatIs.point3') },
    { icon: 'ri-bar-chart-line', text: t('whatIs.point4') },
  ];

  return (
    <section className="section-padding bg-background-50 relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://readdy.ai/api/search-image?query=Stack%20of%20neatly%20folded%20neutral%20colored%20knitwear%20sweaters%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20window%20light%2C%20cozy%20minimal%20product%20photography%2C%20warm%20cream%20and%20taupe%20tones%2C%20clean%20aesthetic&width=1600&height=900&seq=whatis-bg-2&orientation=landscape&nocache=true"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 md:mb-6">
              {t('whatIs.title')}
            </h2>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-6 md:mb-8">
              {t('whatIs.intro')}
            </p>
            <a
              href={prefix + '/cssbuy-spreadsheet'}
              className="btn-primary text-sm"
            >
              {t('whatIs.cta')}
              <i className="ri-arrow-right-line ml-1.5"></i>
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {points.map((point, index) => (
              <div
                key={index}
                className="card p-5 md:p-6 hover:shadow-sm"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 mb-3">
                  <i className={`${point.icon} text-xl`}></i>
                </div>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  {point.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}